import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reports-payments-tab" }
const _hoisted_2 = { class: "reports-tab__toolbar" }
const _hoisted_3 = { class: "reports-tab__toolbar-right" }
const _hoisted_4 = { class: "reports-tab__stats" }
const _hoisted_5 = { class: "reports-payments-tab__chart" }

import { computed } from 'vue';
import DateRangePicker from '@/components/ui/DateRangePicker.vue';
import ReportsStatCards from '@/components/reports/ReportsStatCards.vue';
import BarChart from '@/components/ui/BarChart.vue';
import ToolbarIconButton from '@/components/ui/ToolbarIconButton.vue';
import IconExport from '@/components/icons/IconExport.vue';
import QueuedExportModal from '@/components/modals/QueuedExportModal.vue';
import { useReportsPayments } from '@/composables/useReportsPayments';
import { formatDate } from '@/utils/formatUtils';
import { exportPaymentsReport, type PaymentsReportMetricKey } from '@/services/reportsService';
import { useQueuedExport } from '@/composables/useQueuedExport';
import { useDateRangeWithTimezone } from '@/composables/useDateRangeWithTimezone';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsPaymentsTab',
  setup(__props) {

/* eslint-env vue/setup-compiler-macros */
const { selectedDateRange } = useDateRangeWithTimezone();

const formattedDateRange = computed<[string, string] | null>(() => {
    const range = selectedDateRange.value;
    if (!range) return null;
    return [formatDate(range[0]), formatDate(range[1])];
});

const {
    viewMode,
    activeStatId,
    stats,
    chartData,
    chartOptions,
    openBucket,
    dailyAverage,
    loading,
    rangeIncludesCurrentPeriod,
} = useReportsPayments(formattedDateRange);

const {
    exporting,
    cooldownActive,
    queuedModalVisible,
    queuedTitle,
    queuedMessage,
    run: runExport,
} = useQueuedExport({
    queuedTitle: 'Payments report export started',
    successDetail: 'Payments report CSV downloaded.',
    errorDetail: 'Unable to export the payments report. Please try again.',
});


function exportCsv() {
    const range = formattedDateRange.value;
    if (!range) return;
    const [from, to] = range;

    runExport(() => exportPaymentsReport({
        from,
        to,
        view: viewMode.value,
        metric: activeStatId.value as PaymentsReportMetricKey | null,
    }));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(DateRangePicker, {
          modelValue: _unref(selectedDateRange),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedDateRange) ? (selectedDateRange).value = $event : null)),
          label: "Filter by Date:",
          "trigger-width": "350px",
          "trigger-radius": "10px"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ToolbarIconButton, {
            ariaLabel: "Export",
            disabled: _unref(exporting) || _unref(cooldownActive),
            onClick: exportCsv
          }, {
            default: _withCtx(() => [
              _createVNode(IconExport)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ReportsStatCards, {
          items: _unref(stats),
          "active-id": _unref(activeStatId),
          loading: _unref(loading),
          "onUpdate:activeId": _cache[1] || (_cache[1] = ($event: any) => (activeStatId.value = $event))
        }, null, 8, ["items", "active-id", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BarChart, {
          "chart-data": _unref(chartData),
          "daily-average": _unref(activeStatId) ? _unref(dailyAverage) : null,
          loading: _unref(loading),
          "highlight-current-period": _unref(rangeIncludesCurrentPeriod),
          "chart-options": _unref(chartOptions),
          clickable: "",
          "onUpdate:viewMode": _cache[2] || (_cache[2] = ($event: any) => (viewMode.value = $event)),
          onBarClick: _unref(openBucket)
        }, null, 8, ["chart-data", "daily-average", "loading", "highlight-current-period", "chart-options", "onBarClick"])
      ])
    ]),
    _createVNode(QueuedExportModal, {
      visible: _unref(queuedModalVisible),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(queuedModalVisible) ? (queuedModalVisible).value = $event : null)),
      title: _unref(queuedTitle),
      message: _unref(queuedMessage)
    }, null, 8, ["visible", "title", "message"])
  ], 64))
}
}

})